// MarkdownPreview.jsx
import React, { useEffect, useState } from "react"
import { Box, Typography } from "@mui/material"
import { marked } from "marked"
import DOMPurify from "dompurify"

const MarkdownPreview = ({ markdown = "", showPreview = false }) => {
  const [htmlContent, setHtmlContent] = useState("")

  useEffect(() => {
    marked.setOptions({
      gfm: true,
      breaks: true,
      headerIds: false,
      mangle: false,
    })

    const convertMarkdown = async () => {
      try {
        if (typeof markdown !== "string") {
          throw new Error(`Expected string, got ${typeof markdown}`)
        }

        const rawHtml = await marked(markdown)
        const cleanHtml = DOMPurify.sanitize(rawHtml)
        setHtmlContent(cleanHtml)
      } catch (error) {
        console.error("Error converting markdown:", error)
        setHtmlContent("<p>Error al procesar el markdown</p>")
      }
    }

    convertMarkdown()
  }, [markdown])

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        backgroundColor: "background.paper",
      }}
    >
      {showPreview && (
        <Box
          sx={{
            backgroundColor: "#f0f0f0",
            borderBottom: "1px solid #ccc",
            px: 2,
            py: 1,
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: "bold",
              color: "text.secondary",
              textTransform: "uppercase",
              fontSize: "12px",
            }}
          >
            Preview
          </Typography>
        </Box>
      )}

      {/* Contenido con scroll */}
<Box
  sx={{
    flex: 1,
    p: 2,
    overflowY: "auto",
    maxHeight: "450px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
    lineHeight: 1.4,
    fontSize: "14px",
    backgroundColor: "background.paper",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    "& p": { margin: "8px 0" },
    "& h3": { marginTop: "16px", marginBottom: "8px" },
    "& ul": { marginTop: "4px", marginBottom: "4px", paddingLeft: "20px" },
    "& blockquote": {
      borderLeft: "4px solid #ccc",
      margin: "16px 0",
      paddingLeft: "16px",
      color: "#555",
      fontStyle: "italic",
      backgroundColor: "#f9f9f9",
    },
    "& table": {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "12px",
      marginBottom: "12px",
    },
    "& th, & td": {
      border: "1px solid #ccc",
      padding: "8px",
      textAlign: "left",
    },
    "& th": {
      backgroundColor: "#f5f5f5",
      fontWeight: "bold",
    },
    // 👇 aquí la parte nueva
    "& a": {
      color: "#1976d2",
      textDecoration: "none",
      wordBreak: "break-all",
      overflowWrap: "break-word",
      whiteSpace: "normal",
    },
    "& a:hover": {
      textDecoration: "underline",
    },
  }}
  dangerouslySetInnerHTML={{ __html: htmlContent }}
/>

    </Box>
  )
}

export default MarkdownPreview
